<template>
    <div class="space-y-2">
        <MeetingDetailsSectionTitle iconName="calendar">
            Scheduled Dates
        </MeetingDetailsSectionTitle>
        <div>
            <Table :fullWidth="false">
                <TableBody>
                    <TableBodyRow
                        v-for="meetingRecurringDateInAvailabilityTimezone in meetingRecurringDatesInAvailabilityTimezone"
                        :key="
                            meetingRecurringDateInAvailabilityTimezone.uniqueCode
                        "
                    >
                        <TableBodyRowCell>
                            {{
                                meetingRecurringDateInAvailabilityTimezone.recurringMeetingOrder
                            }}
                        </TableBodyRowCell>
                        <TableBodyRowCell>
                            {{
                                meetingRecurringDateInAvailabilityTimezone
                                    .recurringDate.localizedReadableDate
                            }}
                        </TableBodyRowCell>
                        <TableBodyRowCell>
                            {{
                                meetingRecurringDateInAvailabilityTimezone
                                    .recurringDate.localizedReadableTime
                            }}
                        </TableBodyRowCell>
                        <TableBodyRowCell>
                            {{
                                meetingRecurringDateInAvailabilityTimezone
                                    .recurringDate.localizedDayOfWeekLong
                            }}
                        </TableBodyRowCell>
                        <TableBodyRowCell class="flex justify-end">
                            <div class="flex items-center gap-2">
                                <a
                                    :href="
                                        urlFactory.makeMeetingIndexByUniqueCodeUrl(
                                            meetingRecurringDateInAvailabilityTimezone.uniqueCode,
                                        )
                                    "
                                    class="hover:underline"
                                >
                                    View
                                </a>
                                <Icon
                                    name="arrow-right"
                                    class="w-3.5 h-3.5 text-gray-500"
                                />
                            </div>
                        </TableBodyRowCell>
                    </TableBodyRow>
                </TableBody>
            </Table>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { type PropType } from 'vue'
    import MeetingDetailsSectionTitle from '@/App/Booking/Meeting/Component/MeetingDetailsSectionTitle.vue'
    import MeetingRecurringDate from '@/App/Booking/Recurring/Entity/MeetingRecurringDate'
    import Icon from '@/Shared/Component/Icon.vue'
    import Table from '@/Shared/Component/Table/Table.vue'
    import TableBodyRow from '@/Shared/Component/Table/TableBodyRow.vue'
    import TableBody from '@/Shared/Component/Table/TableBody.vue'
    import TableBodyRowCell from '@/Shared/Component/Table/TableBodyRowCell.vue'

    const props = defineProps({
        meetingRecurringDatesInAvailabilityTimezone: {
            type: Array as PropType<MeetingRecurringDate[]>,
            required: true,
        },
    })
    const urlFactory = new UrlFactory()
</script>
